// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3715":"list","9702":"story"}[chunkId] || chunkId) + "-" + {"2217":"0e98b144f5912d058fc7","3661":"ab810f1e0b729789927b","3715":"3da2d7b772e3e5ad2ff6","9702":"3d02bf8c2e661c55ecdb"}[chunkId] + ".css";
};